import './index.scss';
import React, {useEffect, useState} from 'react';

export default function PdpTextField({
  inputDefaultedValue,
  onHandleChange,
  onBlur
}) {
  // NOT USING PIGMENT DUE TO HARD TO OVERRIDE STYLES WE NEED FOR THIS PROJECT
  //  THIS GETS THE WIDTH OF THE INPUT FIELD BASED ON THE LENGTH OF THE QUOTE QUANTITY
  // ONCE FIELDSIZING IS IN ALL BROWSERS THIS CAN BE REMOVED
  const getWidth = (length) => {
    if (length >= 5) {
      return 67;
    } else if (length === 4) {
      return 57;
    } else if (length === 3) {
      return 46;
    } else {
      return 36;
    }
  };

  const [widths, setWidths] = useState(36);

  useEffect(() => {
    setWidths(getWidth(inputDefaultedValue.toString().length));
  }, [inputDefaultedValue]);

  return (
    <>
      <label htmlFor="inputDefaultedValue" style={{display: 'none'}}>
        Input Defaulted Value
      </label>
      <input
        data-testid="quote-input"
        id="quoteQuantity"
        type="number"
        min="0"
        role="spinbutton"
        aria-label="Quote Quantity"
        className="pc-Price-Detail-Input"
        style={{width: `${widths}px`}}
        value={inputDefaultedValue}
        onChange={(e) => {
          onHandleChange(e.target.value);
        }}
        onBlur={(e) => {
          onBlur(e.target.value);
        }}
        size="small"
      />
    </>
  );
}
